import React from "react";
import {Button, Menu, MenuHandler, MenuItem, MenuList} from "@material-tailwind/react";
import {useTranslation} from "react-i18next";
import {AccountCircle, KeyboardArrowDown, Logout} from "@mui/icons-material";
import CustomBadge from "../general/CustomBadge";
import {CustomTypography} from "../general/CustomTypography";
import {useSessionStore} from "../../services/storage/SessionStorage";
import {logoutSession} from "../../services/session/apiSession";

const ProfileMenu = () => {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const session = useSessionStore(data => data.user)

    const profileMenuItems = [
        {
            label: t('sign-off'),
            icon: Logout,
            option: 1
        },
    ];
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const actionMenu = (option: number) => {
        setIsMenuOpen(false)
        switch (option) {
            case 1 :
                logoutSession()
        }
    };

    return (
        <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end">
            <MenuHandler>
                <Button placeholder={'button-menu'}
                    variant="text"
                    className="flex items-center gap-1 rounded-full py-0.5 ml-auto h-[38px] sm:h-[25px]"
                >
                    <CustomBadge number={0} icon={<AccountCircle className={'text-empColorPrimary ml-[-10px] mt-[-5px]'}/>}/>
                    <span className={'ml-[8px] mr-[14px] text-empColorPrimary text-[11px] sm:text-[14px] lowercase'}>{session ? session?.email : '-'}</span>
                    <div className={`max-w-[10px] max-h-[10px] text-empColorPrimary transition-transform ${isMenuOpen ? "rotate-180" : ""}`}>
                        <KeyboardArrowDown className={`ml-[-7px] mt-[-7px]`}/>
                    </div>
                </Button>
            </MenuHandler>
            <MenuList placeholder='menu-list' className="p-1">
                {profileMenuItems.map(({ label, icon, option }, key) => {
                    const isLastItem = key === profileMenuItems.length - 1;
                    return (
                        <MenuItem placeholder='menu-item'
                            key={label}
                            onClick={() => {
                                actionMenu(option)
                            }}
                            className={`flex items-center gap-2 rounded ${
                                isLastItem
                                    ? "hover:bg-red-500/10 focus:bg-red-500/10 active:bg-red-500/10"
                                    : ""
                            }`}
                        >
                            {React.createElement(icon, {
                                className: `h-4 w-4 ${isLastItem ? "text-red-500" : ""}`,
                                strokeWidth: 2,
                            })}
                            <CustomTypography
                                variant="small"
                                className="font-normal"
                                color={isLastItem ? "red" : "inherit"}
                                text={label}/>
                        </MenuItem>
                    );
                })}
            </MenuList>
        </Menu>
    );
}

export default ProfileMenu
